// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__LyuSP","spinning":"styles_spinning__S_tth","loading-spinner":"styles_loading-spinner__XtXCE"};